export const allowedExchangeTypesValues = {
  exchange: 'exchange',
  instantExchange: 'instantExchange',
  exchangeAndInstantExchange: 'exchangeAndInstantExchange',
}

export const allowedExchangeTypesOptions = [
  {
    value: allowedExchangeTypesValues.exchangeAndInstantExchange,
    label: 'Cambios instantáneos y cambios estándar',
  },
  {
    value: allowedExchangeTypesValues.instantExchange,
    label: 'Cambios instantáneos',
  },
  {
    value: allowedExchangeTypesValues.exchange,
    label: 'Cambios estándar',
  },
]
